/**
 * Home-screen install metadata.
 *
 * A web-app manifest is the largest single lever we have against Safari's
 * storage cleanup: home-screen apps are exempt from the seven-day rule and get
 * their own storage. There is deliberately no service worker — it is not
 * required for Add to Home Screen on modern iOS, and it would bring caching and
 * offline-licensing questions this product does not want yet.
 *
 * TODO: these belong as static tags in index.html <head>. They are injected
 * here only because another branch is holding uncommitted changes to that file;
 * move them across once the tree quiets.
 */

const TAGS: Array<Record<string, string>> = [
  { tag: 'link', rel: 'manifest', href: '/manifest.webmanifest' },
  // The mark is raster art, so there is no vector copy to prefer here.
  { tag: 'link', rel: 'icon', type: 'image/png', href: '/icons/icon-192.png' },
  // iOS reads this one rather than the manifest's icon list.
  { tag: 'link', rel: 'apple-touch-icon', href: '/icons/icon-192.png' },
  { tag: 'meta', name: 'theme-color', content: '#0a0c0a' },
  { tag: 'meta', name: 'apple-mobile-web-app-capable', content: 'yes' },
  { tag: 'meta', name: 'apple-mobile-web-app-title', content: 'Rerun' },
  // The shell is dark to the edges; a translucent bar lets it run under the
  // notch instead of banding the top of the screen in white.
  { tag: 'meta', name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' },
];

export function installPwaMetadata(): void {
  for (const { tag, ...attrs } of TAGS) {
    const selector = 'rel' in attrs ? `link[rel="${attrs.rel}"]` : `meta[name="${attrs.name}"]`;
    if (document.head.querySelector(selector)) continue;
    const el = document.createElement(tag);
    for (const [name, value] of Object.entries(attrs)) el.setAttribute(name, value);
    document.head.appendChild(el);
  }
}
